import type { TreesEditAdapter } from './CompositeGeoEditAdapter';
import type { RemoveTreeOp } from '@visualizer/types';
import type { ObjectVisual } from './Interfaces/ObjectVisual';

export class TreesGeoEditAdapter implements TreesEditAdapter {
    private removedIds = new Set<number>();

    constructor(private readonly visual: ObjectVisual) {}

    applyRemove(op: RemoveTreeOp): void {
        this.removedIds.add(op.id);

        this.visual.hideObject(op.id);
    }

    revertRemove(op: RemoveTreeOp): void {
        this.removedIds.delete(op.id);
        this.visual.showObject(op.id);
    }

    getRemovedIds(): ReadonlySet<number> {
        return this.removedIds;
    }

    isRemoved(id: number): boolean {
        return this.removedIds.has(id);
    }
}
